import { ExpandableInputField } from "@motleyhand/design"
import type { ComponentProps } from "react"
import FormControl from "./FormControl"

export type Props = ComponentProps<typeof ExpandableInputField> & {
  name: string
}

export default function FormExpandableInput({
  name,
  required,
  onChange,
  ...rest
}: Props) {
  return (
    <FormControl name={name} required={required}>
      {({ field, isError, error }) => (
        <ExpandableInputField
          id={name}
          required={required}
          aria-invalid={isError}
          error={error}
          {...field}
          name={name}
          {...rest}
          onChange={(e) => {
            field.onChange(e)
            onChange?.(e)
          }}
        />
      )}
    </FormControl>
  )
}
